import { render, staticRenderFns } from "./ExtractArtist.vue?vue&type=template&id=8afd9f78"
import script from "./ExtractArtist.vue?vue&type=script&lang=js"
export * from "./ExtractArtist.vue?vue&type=script&lang=js"
import style0 from "./ExtractArtist.vue?vue&type=style&index=0&id=8afd9f78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports